/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LocationInner } from './LocationInner';
import {
    LocationInnerFromJSON,
    LocationInnerFromJSONTyped,
    LocationInnerToJSON,
} from './LocationInner';

/**
 * 
 * @export
 * @interface SecReviewValidationError
 */
export interface SecReviewValidationError {
    /**
     * 
     * @type {Array<LocationInner>}
     * @memberof SecReviewValidationError
     */
    loc: Array<LocationInner>;
    /**
     * 
     * @type {string}
     * @memberof SecReviewValidationError
     */
    msg: string;
    /**
     * 
     * @type {string}
     * @memberof SecReviewValidationError
     */
    type: string;
}

/**
 * Check if a given object implements the SecReviewValidationError interface.
 */
export function instanceOfSecReviewValidationError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "loc" in value;
    isInstance = isInstance && "msg" in value;
    isInstance = isInstance && "type" in value;

    return isInstance;
}

export function SecReviewValidationErrorFromJSON(json: any): SecReviewValidationError {
    return SecReviewValidationErrorFromJSONTyped(json, false);
}

export function SecReviewValidationErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecReviewValidationError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'loc': ((json['loc'] as Array<any>).map(LocationInnerFromJSON)),
        'msg': json['msg'],
        'type': json['type'],
    };
}

export function SecReviewValidationErrorToJSON(value?: SecReviewValidationError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'loc': ((value.loc as Array<any>).map(LocationInnerToJSON)),
        'msg': value.msg,
        'type': value.type,
    };
}

